import { Controller } from "stimulus"

export default class extends Controller {
  clearCache() {
    window.Turbo.clearCache()
  }
}
